import { useEffect } from "react";

const SEOHead = ({
  title = "Mohamed Sanaany - Full Stack Developer",
  description = "Full Stack Developer specializing in React, Node.js, and modern web technologies. View my portfolio and get in touch.",
  image = "/og-image.svg",
  url = "https://mohamedsanaany.netlify.app",
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (property, content, isProperty = false) => {
      const selector = isProperty
        ? `meta[property="${property}"]`
        : `meta[name="${property}"]`;
      let meta = document.querySelector(selector);

      if (!meta) {
        meta = document.createElement("meta");
        if (isProperty) {
          meta.setAttribute("property", property);
        } else {
          meta.setAttribute("name", property);
        }
        document.head.appendChild(meta);
      }

      meta.setAttribute("content", content);
    };

    // Basic meta tags
    updateMetaTag("description", description);
    updateMetaTag("author", "Mohamed Sanaany");
    updateMetaTag(
      "keywords",
      "Mohamed Sanaany, Full Stack Developer, React Developer, Web Developer, Portfolio, JavaScript, Node.js"
    );

    // Open Graph meta tags
    updateMetaTag("og:title", title, true);
    updateMetaTag("og:description", description, true);
    updateMetaTag("og:image", `${url}${image}`, true);
    updateMetaTag("og:image:width", "1200", true);
    updateMetaTag("og:image:height", "630", true);
    updateMetaTag("og:image:alt", title, true);
    updateMetaTag("og:url", url, true);
    updateMetaTag("og:type", "website", true);
    updateMetaTag("og:site_name", "Mohamed Sanaany Portfolio", true);

    // Twitter Card meta tags
    updateMetaTag("twitter:card", "summary_large_image");
    updateMetaTag("twitter:title", title);
    updateMetaTag("twitter:description", description);
    updateMetaTag("twitter:image", `${url}${image}`);

    // Update favicon
    const updateIcon = (rel, href, type = null) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", rel);
        document.head.appendChild(link);
      }
      link.setAttribute("href", href);
      if (type) {
        link.setAttribute("type", type);
      }
    };

    updateIcon("icon", "/favicon.svg", "image/svg+xml");
    updateIcon("alternate icon", "/favicon.ico");
    updateIcon("apple-touch-icon", "/apple-touch-icon.png");
  }, [title, description, image, url]);

  return null; // This component doesn't render anything
};

export default SEOHead;
